<template>
    <div class="container-fluid form-container fire-alarm-test-form-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    Fire Alarm Variations
                </h1>
            </div>
        </div>
        <form
            action=""
            class="fire-alarm-certificate"
            @submit.prevent="saveForm()"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                name="customer_id"
                                :errors="errors"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                                @change="siteChanged()"
                            >
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="job_id">Job No.</label>
                            <select
                                v-if="jobs"
                                name="job_id"
                                id="job_id"
                                v-model="form.job_id"
                                class="form-control"
                                placeholder="Select a job"
                                :disabled="jobs.length < 1"
                            >
                                <option
                                    :value="null"
                                    disabled
                                >
                                    Select a job
                                </option>
                                <option
                                    v-for="job in jobs"
                                    :key="job.id"
                                    :value="job.id"
                                >
                                    {{ job.id }}: {{ job.name }}
                                </option>
                            </select>
                            <error
                                name="job_id"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="doc_no">Document No.</label>
                            <input
                                type="text"
                                id="doc_no"
                                name="doc_no"
                                v-model="form.doc_no"
                                placeholder="Document Number"
                                class="form-control"
                            >
                            <error
                                name="doc_no"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12 d-flex align-items-center">
                            <label class="flex-grow-0 text-nowrap mr-2 mb-0">
                                Total Site Variations =
                            </label>
                            <input
                                type="number"
                                readonly
                                class="form-control flex-grow-0 w-auto"
                                name="total_variations"
                                v-model="form.total_variations"
                            >
                        </div>
                        <div class="col-md-12">
                            <error
                                name="total_variations"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <h3>Major System Checks</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <p>The following questions must be answered</p>
                        </div>
                    </div>

                    <select-row-component
                        id="double_pole_fused_spur"
                        label="A. A double pole fused spur has been installed"
                        v-model="form.double_pole_fused_spur"
                        required
                    />

                    <select-row-component
                        id="fused_spur_cable"
                        label="B. The cable from the fused spur to the panel is fire rated"
                        v-model="form.fused_spur_cable"
                        required
                    />

                    <div
                        v-if="form.double_pole_fused_spur === 'No' || form.fused_spur_cable === 'No'"
                        class="row"
                    >
                        <div class="col-sm-12">
                            <p class="font-weight-bold">
                                If any of the above is answered NO - Please detail as a varation below
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <h3>System Variations</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-1">
                                    <label>No.</label>
                                </div>
                                <div class="col-sm-11">
                                    <label>Details of variation</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div
                                        v-for="(variation, index) in form.variations"
                                        class="d-flex align-items-center mb-2"
                                    >
                                        <div
                                            style="width: 5rem"
                                            class="flex-grow-0 flex-shrink-0 mr-1"
                                        >
                                            <input
                                                type="number"
                                                :value="index + 1"
                                                class="form-control"
                                                readonly
                                            >
                                        </div>
                                        <div class="w-full flex-grow-1 mx-1">
                                            <input
                                                type="text"
                                                v-model="form.variations[index]"
                                                class="form-control"
                                            >
                                            <error
                                                name="variations"
                                                :index="index"
                                                :errors="errors"
                                            />
                                        </div>
                                        <div class="flex-grow-0 flex-shrink-0 ml-1">
                                            <button
                                                title="Delete variation"
                                                class="btn btn-sm btn-outline-danger btn-icon"
                                                type="button"
                                                @click.prevent="deleteVariations(index)"
                                                :disabled="form.variations.length < 2"
                                            >
                                                <i class="fa fa-trash" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12 d-flex justify-content-end">
                                    <button
                                        class="btn btn-sm btn-primary"
                                        type="button"
                                        @click.prevent="addVariation()"
                                    >
                                        <i class="fa fa-plus" />
                                        <span>Add Variation</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <text-row-component
                        id="explained_to_name"
                        label="The above variations have been explained to"
                        v-model="form.explained_to_name"
                        placeholder="Name..."
                    />

                    <date-row-component
                        id="explained_on_date"
                        label="And understood on date"
                        v-model="form.explained_on_date"
                        :options="{format: 'L'}"
                    />

                    <text-row-component
                        id="explained_by_name"
                        label="The above variations were explained by engineer"
                        v-model="form.explained_by_name"
                        placeholder="Engineer Name"
                    />

                    <div class="row">
                        <div class="col-sm-12">
                            <p>
                                The above variations have been recorded against the recommendations of the British and
                                European Standards BS 5839 and/or EN54.2
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isLoading || isSaving"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click="deleteForm()"
                                :disabled="isLoading || isSaving"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                                target="_blank"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id && form.customer_id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import CustomerSearchComponent from "../CustomerSearch.vue";
import FormService from "../../services/FormService";
import * as moment from "moment";
import AuthService from "../../services/AuthService";
import UsesErrors from "../../mixins/UsesErrors";
import SettingsMixin from "../../mixins/SystemSettings";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";
import UsesFormRouteQuery, { formRouteQueryWatchers } from "../../mixins/UsesFormRouteQuery";
import SelectRowComponent from "./parts/SelectRowComponent.vue";
import TextRowComponent from "./parts/TextRowComponent.vue";
import DateRowComponent from "./parts/DateRowComponent.vue";
import JobService from "../../services/JobService";

const initialForm = {
    type: 'fire_alarm_variations',
    customer: null,
    total_variations: 0,
    variations: [
        '',
    ],
    explained_on_date: moment(),
};

export default {
    components: {
        DateRowComponent,
        TextRowComponent,
        SelectRowComponent,
        "customer-search": CustomerSearchComponent,
    },
    mixins: [
        UsesErrors,
        UsesInfoMessage,
        SettingsMixin,
        UsesFormRouteQuery,
    ],
    data: function () {
        return {
            form: {...initialForm},
            token: null,
            sites: [],
            jobs: [],
        }
    },
    computed: {
        canDelete: function () {
            return AuthService.user.admin_access || AuthService.user.office_access;
        },
        idParam: function () {
            return this.$route.params.id;
        },
        variationsCount: function () {
            return (this.form.variations || []).filter(v => !!v).length;
        }
    },

    watch: {
        ...formRouteQueryWatchers,
        idParam: {
            handler: function () {
                if (this.idParam) {
                    this.loadForm(this.idParam);
                    return;
                }

                this.form = {...initialForm};
                FormService.nextNo().then(res => {
                    this.form.doc_no = res.data;
                });
            },
            immediate: true,
        },
        variationsCount: {
            handler: function () {
                this.form.total_variations = this.variationsCount;
            },
            immediate: true,
        }
    },

    mounted: function () {

        if (!this.form.explained_by_name && AuthService.user.engineer_access) {
            this.form.explained_by_name = AuthService.user.name;
        }
    },

    methods: {
        loadForm: function (id) {
            this.setLoading();
            FormService.get(id).then(res => {
                this.form = res.data;

                if (!this.form.customer) {
                    this.form.customer = {
                        company_name: '',
                    };
                }

                if (res.data.engineer_sign_date) {
                    this.form.explained_on_date = moment(res.data.explained_on_date);
                } else {
                    this.form.explained_on_date = moment();
                }

                if (!this.form.variations || this.form.variations[0] === undefined) {
                    this.form.variations = initialForm.variations;
                }

            }, () => {
                this.setErrorMessage('Could not load form');
            }).then(() => {
                this.clearLoading();
            });
        },

        customerChanged: function (customer) {
            this.form.customer = customer ? customer : {};
            if (this.form.customer) {
                this.form.customer_id = this.form.customer.id;
                this.getJobs();
            } else {
                this.form.customer_id = null;
            }
            if (customer && customer.sites) {
                if (!customer.sites.map(site => site.id).includes(this.form.site_id)) {
                    this.form.site_id = '';
                    this.siteChanged();
                }
            } else {
                this.form.site_id = '';
                this.siteChanged();
            }
        },

        siteChanged: function () {
            this.loadSiteVariations();
        },

        saveForm: function () {
            this.setSaving();
            let data = {...this.form};
            delete data['customer'];
            delete data['site'];
            delete data['job'];
            delete data['data'];

            data.variations = data.variations.filter(v => !!v);

            if (this.form.id) {
                FormService.update(data).then(
                    res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        this.$emit('formSaved', res.data);
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            } else {
                FormService.create(data).then(
                    res => {
                        this.setInfoMessage("Form saved successfully");
                        this.clearSaving();
                        if (this.$route.path.includes('engineer/')) {
                            this.$router.push({
                                name: "engineer.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        } else {
                            this.$router.push({
                                name: "office.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        }
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            }
        },

        deleteForm: function () {
            if (confirm("Are you sure you want to delete this form?")) {
                FormService.delete(this.form).then(
                    () => {
                        this.setInfoMessage("Form successfully deleted");
                        this.$router.push({name: 'office.forms.search'});
                    },
                    () => {
                        this.setErrorMessage("Could not delete this form");
                    }
                )
            }
        },

        addVariation: function () {
            this.form.variations.push('');
        },

        deleteVariations: function (index) {
            this.form.variations.splice(index, 1);
        },

        loadSiteVariations: function () {
            if (!this.form.site_id) {
                return;
            }

            window.axios.get(`/api/sites/${this.form.site_id}/variations`).then(({data}) => {
                if (data.length < 1) {
                    return;
                }

                if (this.variationsCount > 0) {
                    const confirm = window.confirm("Override current variations with those previously saved to site?");
                    if (!confirm) {
                        return;
                    }
                }
                this.form.variations = data.map(v => v.variation_text);
                this.setInfoMessage('Site variations loaded successfully');
            }).catch(error => {
                this.setErrorMessage('Failed to load variations from site');

                console.error(error);
            })
        },

        onJobLoadedFromRoute() {
            this.siteChanged();
            this.getJobs();
        },

        getJobs: function () {
            if (!this.form.customer_id) {
                this.jobs = [];
                this.form.job_id = null;
                return;
            }
            JobService.search({
                "filter[customer_id]": this.form.customer_id,
            }).then(
                (res) => {
                    this.jobs = res.data.data || [];
                },
                (err) => {
                    this.setErrorMessage("Could not load customer jobs");
                    this.jobs = [];
                }
            );
        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/FireAlarmVariationsComponent.vue